import { Capacitor } from "@capacitor/core";
import { requestAndSaveNotificationToken } from "./notificationService";
import {
  getNativePushPermissionStatus,
  openNativeNotificationSettings,
  registerNativePush,
  requestNativePushPermission,
} from "./nativeNotificationService";

const PENDING_PREFIX = "fp:push-enable-pending:";
export const PUSH_PERMISSION_EVENT = "fp:push-permission-changed";

export function setPushEnablePending(uid, pending) {
  if (!uid) return;
  try {
    const key = `${PENDING_PREFIX}${uid}`;
    if (pending) localStorage.setItem(key, "1");
    else localStorage.removeItem(key);
  } catch {}
}

export function isPushEnablePending(uid) {
  try { return !!uid && localStorage.getItem(`${PENDING_PREFIX}${uid}`) === "1"; }
  catch { return false; }
}

export function emitPushPermissionChanged(status) {
  try { window.dispatchEvent(new CustomEvent(PUSH_PERMISSION_EVENT, { detail: { status } })); }
  catch {}
}

export async function getPushPermissionStatus() {
  if (Capacitor.isNativePlatform()) return getNativePushPermissionStatus();
  if (!("Notification" in window)) return "unsupported";
  return Notification.permission === "default" ? "prompt" : Notification.permission;
}

export async function requestPushAccess({ user, familyId, lang }) {
  if (Capacitor.isNativePlatform()) {
    const status = await requestNativePushPermission();
    if (status === "granted") await registerNativePush({ user, familyId, lang, silent: false });
    emitPushPermissionChanged(status);
    return status;
  }

  const result = await requestAndSaveNotificationToken({ user, familyId, lang });
  const status = result ? "granted" : await getPushPermissionStatus();
  emitPushPermissionChanged(status);
  return status;
}

export async function openPushSettings() {
  return openNativeNotificationSettings();
}
